import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rutaDireccion } from '../_direccion.js';

/**
 * Vive dentro del grupo `_direccion`, así que el guardián de `usuario.administrar` ya se
 * aplicó y esta ruta no repite ninguna verificación. Es la razón de ser de los grupos.
 *
 * El componente llega a pedido, con lo que arrastra: `@tanstack/query` y la pantalla
 * entera. Es la única ruta del proyecto que usa consultas, así que sin esto el operario
 * descargaría el cliente de consultas para no usarlo jamás.
 */
export const rutaUsuarios = createRoute({
  getParentRoute: () => rutaDireccion,
  path: '/usuarios',
  component: lazyRouteComponent(() => import('./usuarios-pantalla.js'), 'RutaUsuarios'),
});
